module.exports = __webpack_public_path__ + "dc56e1efe5ecf8524fd0a671d295ebc3.svg";